module.exports = __webpack_public_path__ + "static/media/filesBoard.645879b2.svg";